import { FC } from 'react'

/* Components */
import WaveSkeleton from './WaveSkeleton'

interface Props {
  secondBreakpoint?: boolean
}

const StubPerformanceChart: FC<Props> = ({ secondBreakpoint }) => {
  const size = secondBreakpoint ? 216 : 197

  return <WaveSkeleton variant="circular" width={size} height={size} />
}

export default StubPerformanceChart
